<template>
	<div class="bipolar-chart-container">
		<div class="bipolar-chart" v-for="(seq, k) in data" :key="k">
			<div class="bipolar-chart-item" v-for="(v, k) in seq.data" :key="k">
				<div class="bipolar-chart-fullness" :style="{width: v < 5.5 && v !== 0 ? ((5.5 - v) * 20) + '%' : (v -5.5) * 20 + '%' , 'background-color': seq.color, 'min-width': '5px'}">
				</div>
				<span class="bipolar-chart-score">&nbsp;</span>
				<span class="bipolar-chart-title" :style="{color: v === 0 && v !== '5.5'  ? '#9A9BA0' : '#0C0C0D'}">
					{{ k }}
				</span>
			</div>
		</div>
	</div>
</template>

<style lang="css">
	/*Test chart*/
	.bipolar-chart-item:nth-child(odd) {
		border-right: 1px solid #282C58;
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
	}

	.bipolar-chart-item:nth-child(even) {
		flex-direction: row-reverse;
		border-left: 1px solid #282C58;
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
	}

	.bipolar-chart-item:nth-child(odd) .bipolar-chart-score {
		margin-right: 8px;
	}

	.bipolar-chart-item:nth-child(even) .bipolar-chart-score {
		margin-left: 8px;
	}

	.bipolar-chart-item:nth-child(even) .bipolar-chart-fullness {
		border-top-right-radius: 4px;
		border-bottom-right-radius: 4px;
		left: 0;
	}

	.bipolar-chart-item:nth-child(odd) .bipolar-chart-fullness {
		border-top-left-radius: 4px;
		border-bottom-left-radius: 4px;
		right: 0;
	}

	.bipolar-chart {
		display: flex;
	}

	.bipolar-chart-item {
		background-color: #EFEFFF;
		position: relative;
		width: 50%;
		padding: 14px 12px;
		display: flex;
		flex-direction: row;
		align-items: center;
		overflow: hidden;
		margin-bottom: 6px;
	}

	.bipolar-chart-fullness {
		position: absolute;
		top: 0;
		height: 100%;
		display: block;
		z-index: 0;
	}

	.bipolar-chart-item .bipolar-chart-score {
		font-weight: 700;
		font-size: 16px;
		z-index: 1;
	}

	.bipolar-chart-item .bipolar-chart-title {
		font-size: 14px;
		z-index: 1;
	}

	@media (max-width: 375px) {
		.bipolar-chart-item .bipolar-chart-score {
			font-size: 12px;
		}

		.bipolar-chart-item .bipolar-chart-title {
			font-size: 10px;
		}
	}
</style>

<script>
	export default {
		props: {
			data: {
				type: Array,
				default: () => {
					return []
				},
				required: true
			}
		}
	}
</script>
